import { useLanguage } from '../contexts/LanguageContext';
import { translationService } from '../services/translationService';

export function useTranslation() {
  const { currentLanguage } = useLanguage();

  return {
    // Main translation function
    t: (key, params = {}) => translationService.t(key, currentLanguage, params),
    
    // Current language
    currentLanguage,
    
    // Language utilities
    getAvailableLanguages: () => translationService.getAvailableLanguages(),
    getLanguageName: (code) => translationService.getLanguageName(code),
    getLanguageOptions: () => translationService.getLanguageOptions(),
    hasTranslation: (key) => translationService.hasTranslation(key, currentLanguage),
    getAllTranslations: (key) => translationService.getAllTranslations(key)
  };
} 